import { StringNullableChain } from 'lodash'
import sharedStore from '@/modules/shared/shared.store'
import store from '@/store'
import { getModule } from 'vuex-module-decorators'

export interface GameType {
  code: string
  name: StringNullableChain
}

export function getGameTypes() {
  const sharedModule = getModule(sharedStore, store)
  return sharedModule.applicationSupportedGames
}
